import React from 'react';
import PropTypes from 'prop-types';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Link from 'housecall-ui/dist/DesignSystem/Navigation/Link/Link';
import FormTextField from '../../../Common/Form/FormTextField.js';
import StateSelectFormField from '../../../Common/Form/Fields/StateSelectFormField';
import FormCheckbox from '../../../Common/Inputs/FormControls/FormCheckbox';
import MojioCountrySelect from './CountrySelect';

const useStyles = makeStyles(() => ({
  labelStyle: {
    position: 'relative',
    paddingLeft: 30,
    display: 'block',
    paddingTop: 10,
  },
  inputStyle: {
    position: 'absolute',
    top: 0,
    left: -12,
  },
}));

const ShippingAddressFormFields = ({isAddressConfirmation}) => {
  const { labelStyle, inputStyle } = useStyles();
  let terms =""
  if(isAddressConfirmation){
    terms = <div>
    <label className={labelStyle} htmlFor="mojio_terms">
      <FormCheckbox name="agree_mojio_tc" className={inputStyle} id="mojio_terms" />
        <Typography paragraph>
          By submitting your shipping address, you confirm that you accept the Force By Mojio
          {' '}
          <a href="https://forcebymojio.com/terms/" target="_blank" rel="noopener noreferrer">Terms of Service</a>
          {' '}
          and
          {' '}
          <a href="https://forcebymojio.com/privacy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          .
        </Typography>
      </label>
    </div>
  }else{
    terms =  <div>
        If you do not receive your return label via email within 1 business day, contact support.
        <br/>
      Note: Any devices not returned within 30 days will incur a $150 charge each.
      {' '}
      <Link href="https://help.housecallpro.com/en/articles/6613406-vehicle-gps-tracking-downgrade-process">See details here.</Link>
    </div>
  }

  return (
    <Grid container spacing={16}>
      <Grid item xs={6}>
        <FormTextField
          fullWidth
          label="First name"
          name="first_name"
          variant="filled"
        />
      </Grid>
      <Grid item xs={6}>
        <FormTextField
          fullWidth
          label="Last name"
          name="last_name"
          variant="filled"
        />
      </Grid>
      <Grid item xs={12}>
        <FormTextField
          fullWidth
          label="Business name"
          name="business_name"
          variant="filled"
        />
      </Grid>
      <Grid item xs={12}>
        <FormTextField
          fullWidth
          label="Phone number"
          name="phone"
          variant="filled"
        />
      </Grid>
      <Grid item xs={12}>
        <FormTextField
          name="street_line1"
          label="Street address (non - P.O. box)"
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <FormTextField
          name="street_line2"
          label="Apartment, suite, etc. (optional)"
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <FormTextField
          fullWidth
          label="City"
          name="city"
          variant="filled"
        />
      </Grid>
      <Grid item xs={4}>
        <StateSelectFormField
          name="state"
          label="State"
          variant="filled"
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <MojioCountrySelect
          name="country"
          label="Country"
          variant="filled"
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <FormTextField
          fullWidth
          normalize="zip"
          label="Zip code"
          name="postal_code"
          variant="filled"
        />
      </Grid>
      <Grid item xs={12}>
        {terms}
      </Grid>
    </Grid>
  );
};

ShippingAddressFormFields.propTypes = {
  isAddressConfirmation: PropTypes.bool
}

export default React.memo(ShippingAddressFormFields);
